// The Rails CSRF token from the layout's csrf_meta_tags, for fetch requests.
export function csrfToken(doc = document) {
  return doc.querySelector("meta[name='csrf-token']")?.content || ""
}
